module.exports = __webpack_public_path__ + "media/images/topics/topics-grid-bg-cul-dd611b679b3a07fd168ff0c7bc5f8551.png";